import styles from "./styles.module.scss";
import { Button, ButtonGroup, Stack, useTheme } from "@mui/material";
import React, { FunctionComponent, useState } from "react";
import { Icon, IconType } from "../../icons";

export const Counter: FunctionComponent<ICounterProps> = ({
  className,
  initialValue,
  minimumValue,
  maximumValue,
  nullable,
  disabled,
  onValueChanged
}) => {
  const theme = useTheme();
  const [incrementalNumber, setIncrementalNumber] = useState(initialValue);
  return (
    <Stack
      className={className}
      direction={"row"}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <p className={styles.number}>{incrementalNumber >= minimumValue ? incrementalNumber : "-"}</p>
      <ButtonGroup
        variant="contained"
        disabled={disabled}
        size={"medium"}
        sx={{ height: "36px", borderRadius: "12px" }}
        color={"secondary"}
      >
        <Button
          className={styles.incrementalButton}
          sx={{
            color: `${theme.palette.primary.main} !important`,
            backgroundColor: `${theme.palette.colors?.counterBackground} !important`,
            borderRadius: "12px"
          }}
          onClick={() => {
            if (incrementalNumber > minimumValue) {
              onValueChanged(incrementalNumber - 1);
              setIncrementalNumber(incrementalNumber - 1);
            } else if (nullable) {
              onValueChanged(null);
              setIncrementalNumber(minimumValue - 1);
            }
          }}
        >
          <Icon type={IconType.Remove} />
        </Button>
        <Button
          className={styles.incrementalButton}
          sx={{
            color: `${theme.palette.primary.main} !important`,
            backgroundColor: `${theme.palette.colors?.counterBackground} !important`,
            borderRadius: "12px"
          }}
          onClick={() => {
            if (incrementalNumber < (maximumValue ?? Number.MAX_SAFE_INTEGER)) {
              onValueChanged(incrementalNumber + 1);
              setIncrementalNumber(incrementalNumber + 1);
            }
          }}
        >
          <Icon type={IconType.Add} />
        </Button>
      </ButtonGroup>
    </Stack>
  );
};

export interface ICounterProps {
  className?: string;
  initialValue: number;
  minimumValue: number;
  maximumValue?: number;
  nullable: boolean;
  disabled?: boolean;
  onValueChanged: (newValue: number | null) => void;
}
